export default {
  getDetail: state => state.detail,
  getInquiryList: state => state.inquiryList,
  getCondition: state => state.condition,
  getPageInfo: state => state.pageInfo
};
